import React from 'react'
import styled from 'styled-components'
import { TableHeader, TableRow, Text } from 'grommet'
import TableHeaderCell from '@components/Table/TableHeaderCell'

export default ({ columns, changeOrderBy, orderBy }) => {
    return (
        <TableHeaderRow>
            {columns.map(
                (c, ci) =>
                    !c.hidden && (
                        <TableHeaderCell
                            key={'col-header-' + ci}
                            col={c}
                            orderBy={orderBy}
                            changeOrderBy={changeOrderBy}
                        />
                    )
            )}
        </TableHeaderRow>
    )
}

const TableHeaderRow = styled(TableRow)`
    background-color: rgb(152, 135, 152);
    width: 100%;
    flex-direction: row;
`
